import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Box, Button } from '@material-ui/core'
import WarningIcon from '@material-ui/icons/Warning'
import { FormLoader } from '../../components/Loader/FormLoader'
import { formStyles } from '../../components/Invoice/Steps/FormStyles'

const DraftDeleteForm = ({ loading, currentData, isBulk, isTemplate, onSubmit, cancelDialog, updateSelectedRows }) => {
  const classes = formStyles()
  let values = { ids: isBulk ? currentData?.map(item => item?.id) : [currentData?.id] }
  // let values = { id: currentData?.id }
  let internalIds = !!isTemplate
    ? (isBulk ? `\n${currentData?.map(item => item?.name).join('\n')}\n\n` : currentData?.name)
    : (isBulk ? `\n${currentData?.map(item => item?.document?.internalID).join('\n')}\n\n` : currentData?.document?.internalID)

  let internalIdsToast = !!isTemplate
    ? (isBulk ? currentData?.map(item => item?.name).join(',') : currentData?.name)
    : (isBulk ? currentData?.map(item => item?.document?.internalID).join(',') : currentData?.document?.internalID)

  return (
    <Box className={classes.DeleteWrapper}>
      {!!loading && <FormLoader loading={true}/>}

      <WarningIcon className={classes.DeleteWarningIcon}/>
      <p><FormattedMessage id={`${!!isTemplate ? 'Template' : 'Draft'}.DeleteMessage${!!isBulk ? '.bulk' : ''}`}
                           values={{
                             name: internalIds,
                             strong: chunks => <strong>{chunks}</strong>
                           }}/>
      </p>


      <div className={classes.FormSubmitRow}>
        <Button type="submit" variant='contained' size={'medium'} color={'secondary'}
                onClick={() => onSubmit(values, null, () => updateSelectedRows(isBulk ? currentData?.map(item => item?.id) : [currentData?.id]), internalIdsToast)}>
          <FormattedMessage id={'ActionsMenu.button.delete'}/>
        </Button>
        <Button variant='outlined' color='secondary'
                onClick={cancelDialog} className={'cancel'}>
          <FormattedMessage id='AddNewDialog.Cancel'/>
        </Button>
      </div>
    </Box>
  )
}

export default DraftDeleteForm
